import { on } from 'delegated-events'
import {
  setCurrentPaymentMethod,
  setTotal,
  setupPayment,
  setupProcessingFees,
  handleInitialLoad,
} from '../common/payments'
import { buildRules, validate } from '../common/validation'

const form = document.querySelector('form.donation-form')
const submitButton = form ? form.querySelector('[name=action_submit]') : null
const presetAmounts = form ? form.querySelectorAll('input[name="PresetAmount"]') : null
const otherAmount = form ? form.querySelector('input[name="OtherAmount"]') : null
const totalFields = form ? form.querySelectorAll('.donation-total-field') : null

const state = {
  currentPaymentMethod: null,
  stripe: null,
  stripeCard: null,
  stripeElements: null,
  paypal: null,
  paypalButtons: null,
  paymentRequest: null,
  currentTotal: 0,
  isRepeating: false,
  isPreset: true,
}

const fn = {
  init: () => {
    state.stripe = window.Stripe(form.dataset.stripePubKey)
    fn.setupAmount()
    handleInitialLoad(state, form)
    setCurrentPaymentMethod(state, form)
    setupPayment(state, form)
    setupProcessingFees()
    fn.updatePayment()
    fn.setIsRepeating()
    fn.setIsPreset()
    fn.setupPaymentTypeVisibility()
    fn.setupPaymentSection()

    const presetAmount = document.querySelector('input[name="PresetAmount"]:checked')

    if (presetAmount && presetAmount.value !== 'Other') {
      state.currentPaymentMethod = 'credit-card'
      state.currentTotal = presetAmount.value
      setTotal(state, presetAmount.value, totalFields, '$', '.00')
    }

    on('reset', 'form.donation-form', () => {
      const holder = document.getElementById('donation-form')

      if (holder) {
        holder.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
      }
    })
  },

  updatePayment: () => {
    on('change', 'input[name="PaymentMethod"]', () => {
      setCurrentPaymentMethod(state, form)
      setupPayment(state, form)
    })
    on('change', 'input[name="PresetAmount"]', () => {
      setCurrentPaymentMethod(state, form)
      setupPayment(state, form)
    })
    on('change', 'input[name="DonationType"]', () => {
      setCurrentPaymentMethod(state, form)
      setupPayment(state, form)
    })
    on('change', 'input[name="OtherAmount"]', () => {
      setCurrentPaymentMethod(state, form)
      setupPayment(state, form)
    })
  },

  setIsRepeating: () => {
    on('change', 'input[name="DonationType"]', () => {
      state.isRepeating = document.querySelector('input[value="Recurring"]').checked
    })
  },

  setIsPreset: () => {
    on('change', 'input[name="PresetAmount"]', () => {
      state.isPreset = !document.querySelector('input[value="Other"]').checked
    })
  },

  setupPaymentTypeVisibility: () => {
    on('change', 'input[name="DonationType"]', () => {
      //!state.isPreset && state.isRepeating
      state.isRepeating
        ? document.querySelector('li[data-key="paypal"]').classList.add('hidden')
        : document.querySelector('li[data-key="paypal"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="bitcoin"]').classList.add('hidden')
        : document.querySelector('li[data-key="bitcoin"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="apple-pay"]').classList.add('hidden')
        : document.querySelector('li[data-key="apple-pay"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="google-pay"]').classList.add('hidden')
        : document.querySelector('li[data-key="google-pay"]').classList.remove('hidden')
    })

    on('change', 'input[name="PresetAmount"]', () => {
      //!state.isPreset && state.isRepeating
      state.isRepeating
        ? document.querySelector('li[data-key="paypal"]').classList.add('hidden')
        : document.querySelector('li[data-key="paypal"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="bitcoin"]').classList.add('hidden')
        : document.querySelector('li[data-key="bitcoin"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="apple-pay"]').classList.add('hidden')
        : document.querySelector('li[data-key="apple-pay"]').classList.remove('hidden')
      state.isRepeating
        ? document.querySelector('li[data-key="google-pay"]').classList.add('hidden')
        : document.querySelector('li[data-key="google-pay"]').classList.remove('hidden')
    })
  },

  setupPaymentSection: () => {
    const paymentFields = document.querySelector('.payment-fields')
    const paymentFieldsEmpty = document.querySelector('.payment-fields-empty')

    const formIsValid = () => {
      const rules = buildRules(form)
      const result = validate(form, rules)

      return result === undefined
    }

    const handleToggle = () => {
      const isValid = formIsValid()

      if (isValid) {
        paymentFields.classList.remove('hidden')
        paymentFieldsEmpty.classList.add('hidden')
        submitButton.disabled = false
      } else {
        paymentFields.classList.add('hidden')
        paymentFieldsEmpty.classList.remove('hidden')
        submitButton.disabled = true
      }
    }

    handleToggle()

    on('change', '.required-for-payment input', handleToggle, { capture: true })
    on('change', '.required-for-payment select', handleToggle, { capture: true })
  },

  setupAmount: () => {
    presetAmounts.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          let value = radio.value
          if (value !== 'Other') {
            setTotal(state, value, totalFields, '$', '.00')
          }
        }
      })
    })
    otherAmount.addEventListener('change', () => {
      presetAmounts.forEach((radio) => {
        if (radio.checked) {
          let value = radio.value
          if (value === 'Other') {
            const newValue = otherAmount.value
            setTotal(state, Number(newValue).toFixed(2), totalFields, '$', '')
          }
        }
      })
    })
  },
}

export default {
  can: () => document.querySelectorAll('#donation-form').length,
  run: fn.init,
}
